import * as core from '../../../../../../../core'

import { query } from './trends-table-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.trends.trends-table',
    description:
      'Table to be used in tandem with the stacked trends bar chart, displaying same info in table form.',
    name: 'RP Trends - Organization Trends Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
